import { AxiosInstance } from 'axios'

import { PaginateDTO } from '@shared/dto/PaginateDTO'

import {
  FindReturnTaxesPaginatedRequest,
  GetSumReturnTaxByStatusRequest,
  RequestRecalculateReturnTaxRequest,
  UploadReturnTaxReceiptFileRequest,
} from '@modules/return-taxes/types/requests'
import { ReturnTax, SumReturnTaxByStatus } from '@modules/return-taxes/types/returnTaxes'

export class ReturnTaxesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async getPaginated(data: FindReturnTaxesPaginatedRequest): Promise<PaginateDTO<ReturnTax>> {
    const { ...params } = data

    const response = await this.instance.get(`/companies/return-taxes`, { params })

    return response.data
  }

  async getSumReturnTaxByStatus(data: GetSumReturnTaxByStatusRequest): Promise<SumReturnTaxByStatus> {
    const { ...params } = data

    const response = await this.instance.get(`/companies/return-taxes/sum`, { params })

    return response.data
  }

  async requestRecalculateReturnTax(data: RequestRecalculateReturnTaxRequest): Promise<ReturnTax> {
    const { returnTaxId, ...body } = data

    const response = await this.instance.post(`/companies/return-taxes/${returnTaxId}/recalculate`, body)

    return response.data
  }

  async uploadReceiptFile(data: UploadReturnTaxReceiptFileRequest): Promise<ReturnTax> {
    const { returnTaxId, file } = data

    const formData = new FormData()
    formData.append('receipt', file)

    const url = `/companies/return-taxes/${returnTaxId}/receipt`

    const response = await this.instance.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })

    return response.data
  }
}

export const returnTaxesService = (instance: AxiosInstance) => new ReturnTaxesService(instance)
